<template>
    <div>
        <!-- Modal -->
        <div id="clientIdModal" class="modal fade" role="dialog">
            <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">{{ 'Edit Client Id' }}</h4>
                        <button type="button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @keydown="form.errors.clear($event.target.name)">
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="sequential_team_id"
                                       :class="{'text-red': form.errors.has('sequential_team_id')}">Client Id</label>
                                <input type="number" v-model="form.sequential_team_id" id="sequential_team_id" name="sequential_team_id" maxlength="15"
                                       class="appearance-none bg-grey-lightest border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-full"
                                       :class="{'border-red': form.errors.has('sequential_team_id')}">
                                <div class="text-red text-xs" v-if="form.errors.has('sequential_team_id')">
                                    {{ form.errors.get('sequential_team_id') }}
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button @click.prevent="saved"
                                class="bg-followup-nav hover:bg-followup-nav-darker p-2 rounded text-white focus:outline-none">
                            Save
                        </button>
                    </div>
                </div>

            </div>
        </div>

        <div v-if="zero_search_results || companies.length > 0" class="text-grey-darkest">
            <div class="flex justify-start">
                <div class="text-2xl text-grey-darkest mr-2">Clients</div>

                <div class="w-1/2 flex">
                    <div class="bg-grey-lighter rounded-full w-1/3 flex items-center">
                        <input ref="filter" type="search" class="bg-grey-lighter text-grey-darkest w-5/6 focus:outline-none p-1 rounded-full ml-3 text-sm"
                               placeholder="Search by name..." @input="debounceFilter" v-model="filter">
                        <div class="flex-1 text-right pr-3">
                            <i v-if="data_loading" class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="zero_search_results">
                <div class="mt-32 text-center text-grey-darkest text-lg">No results found. Consider changing your search or creating a new company.</div>
            </div>
            <div v-if="companies.length > 0" class="bg-white shadow-md rounded mb-6 mt-4">
                <table class="text-left w-full border-collapse">
                    <thead>
                    <tr>
                        <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                            Client ID
                        </th>
                        <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light" :class="{'text-primary font-weight-bold':sort.colunm === 'name'}" @click="sortBy('name')">
                            Client
                            <i  class="fa fa-xs ml-2"
                                :class="{'fa-chevron-up' : sort.direction === 'asc',
                                    'fa-chevron-down' : sort.direction === 'desc'}"
                                v-if="sort.colunm === 'name'">
                            </i>
                        </th>
                        <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light" :class="{'text-primary font-weight-bold': sort.colunm === 'contact'}" @click="sortBy('contact')">
                            Contact
                            <i  class="fa fa-xs ml-2"
                                :class="{'fa-chevron-up' : sort.direction === 'asc',
                                    'fa-chevron-down' : sort.direction === 'desc'}"
                                v-if="sort.colunm === 'contact'">
                            </i>
                        </th>
                        <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light" :class="{'text-primary font-weight-bold': sort.colunm === 'email'}" @click="sortBy('email')">
                            Email
                            <i  class="fa fa-xs ml-2"
                                :class="{'fa-chevron-up' : sort.direction === 'asc',
                                    'fa-chevron-down' : sort.direction === 'desc'}"
                                v-if="sort.colunm === 'email'">
                            </i>
                        </th>
                        <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light" :class="{'text-primary font-weight-bold': sort.colunm === 'phone'}" @click="sortBy('phone')">
                            Phone
                            <i  class="fa fa-xs ml-2"
                                :class="{'fa-chevron-up' : sort.direction === 'asc',
                                    'fa-chevron-down' : sort.direction === 'desc'}"
                                v-if="sort.colunm === 'phone'">
                            </i>
                        </th>
                        <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light" :class="{'text-primary font-weight-bold': sort.colunm === 'address'}" @click="sortBy('address')">
                            Address
                            <i  class="fa fa-xs ml-2"
                                :class="{'fa-chevron-up' : sort.direction === 'asc',
                                    'fa-chevron-down' : sort.direction === 'desc'}"
                                v-if="sort.colunm === 'address'">
                            </i>
                        </th>
                        <th class="py-2 pl-2 pr-4 bg-grey-lightest border-b border-grey-light"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="hover:bg-grey-lighter" v-for="(company, idx) in companies" :key="idx">
                        <td class="pl-4 py-2 border-b border-grey-light text-xs">
                            <div class="text-sm">{{ company.sequential_team_id }}</div>
                        </td>
                        <td class="pl-4 py-2 border-b border-grey-light text-xs">
                            <div class="text-sm">{{ company.name }}</div>
                            <a v-if="company.phone" :href="`tel:${company.phone}`" class="text-teal hover:text-teal-dark">{{ company.phone.replace(/^(\d{3})(\d{3})(\d{4}).*/, '($1) $2-$3') }}</a>
                        </td>
                        <td class="pl-4 py-2 border-b border-grey-light text-xs">
                            <div v-if="company.contact">
                                {{contractName(company)}}
                            </div>
                        </td>
                        <td class="pl-4 py-2 border-b border-grey-light text-xs">
                            <div><a :href="`mailto:${company.contact.email}`" class="text-teal hover:text-teal-dark">{{ company.contact.email }}</a></div>
                        </td>
                        <td class="pl-4 py-2 border-b border-grey-light text-xs">
                            <a v-if="company.phone" :href="`tel:${company.phone}`" class="text-teal hover:text-teal-dark">{{ company.phone.replace(/^(\d{3})(\d{3})(\d{4}).*/, '($1) $2-$3') }}</a>
                        </td>
                        <td class="pl-2 py-2 border-b border-grey-light text-xs">
                            <div>{{ company.address }}</div>
                            <div>{{ company.city }}</div>
                        </td>
                        <td class="pl-2 pr-4 py-2 border-b border-grey-light text-right">
                            <button @click.stop="editCode(company)"
                                    class="material-icons text-base text-grey-darkest hover:text-grey-darkest focus:outline-none hover:cursor-pointer">edit
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="pagination.meta.total > pagination.meta.per_page" class="flex justify-center">
                <b-pagination
                    @change="goToPage"
                    v-model="pagination.meta.current_page"
                    :total-rows="pagination.meta.total"
                    :per-page="pagination.meta.per_page"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                >
                </b-pagination>
            </div>
        </div>
        <div v-else-if="data_loading" class="text-5xl text-grey-darkest text-center mt-32">
            <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
        </div>
        <div v-else class="mt-10 text-center">
            <div class="flex-col">
                <div>
                    <img width="400" src="images/empty.svg">
                </div>
                <div class="mt-4">
                    <div class="text-lg text-grey-darkest mb-2 flex justify-center">
                        <div class="text-xl w-1/4 tracking-wide">You haven't created a company yet!</div>
                    </div>
                    <button @click="addCompany" class="bg-followup-nav px-4 py-2 rounded-full text-white focus:outline-none hover:bg-followup-nav-darker text-xl">Click here to add your first company!</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import Form        from "../../../utils/form";

    export default {
        name:'client-id',

        data() {
            return {
                companies: '',
                filter: '',
                sort :{
                    direction: 'asc',
                    colunm: 'name'
                },
                page: 1,
                pagination: {
                    data: [],
                    meta: {},
                    links: {},
                },
                data_loading: true,
                zero_search_results: false,
                companyTypes:[],
                advanced_search: false,
                advanced_form:{
                    name: '',
                    address: '',
                    city: '',
                    state: '',
                    zip_code:'',
                    phone: '',
                    fax:'',
                    company_type:null
                },
                company: null,
                form: new Form({
                    sequential_team_id: '',
                }),
            }
        },
        components:{Multiselect},
        created() {
            this.fetchData();
            this.getCompanyTypes();
        },

        methods: {

            goToPage(page) {
                this.page = page;
                this.advanced_search ? this.advancedSearch() : this.fetchData();
            },

            fetchData() {
                let params = {
                    filter: this.filter,
                    colunm:this.sort.colunm,
                    direction: this.sort.direction,
                    page: this.page
                };

                this.data_loading = true;
                axios.get(route('api.company.index'), {params}).then(({data}) => {
                    this.companies = data.data;
                    this.pagination = data;
                    this.data_loading = false;
                    this.zero_search_results = (this.filter && this.companies.length === 0);
                });
            },

            debounceFilter: _.debounce(function (e) {
                this.filter = e.target.value;
                this.advanced_search = false;
                this.goToPage(1)
            }, 700),

            contractName(company){
                return `${company.contact.title ? company.contact.title : ''} ${company.contact.name ? company.contact.name : ''}`;
            },

            sortBy(colunm){
                this.sort.direction = this.sort.colunm === colunm ? (this.sort.direction === 'asc' ? 'desc' : 'asc') : 'asc';
                this.sort.colunm = colunm;
                this.goToPage(1);
            },

            getCompanyTypes() {
                let self = this;
                axios.get(route('api.settings.codes.company-type.index')).then(({data}) => {
                    self.companyTypes = data;
                    self.companyTypes.push({id:null,code:""})
                });
            },

            advancedSearch(){
                let params = {
                    page:this.page,
                    colunm:this.sort.colunm,
                    direction: this.sort.direction,
                    advanced_filter: true,
                    ...this.advanced_form

                };
                params.company_type = params.company_type ? params.company_type.id : null;
                this.data_loading = true;
                axios.get(route('api.company.index'), {params}).then(({data}) => {
                    this.companies = data.data;
                    this.pagination = data;
                }).finally(()=>{
                    this.data_loading = false;
                });
            },
            resetAdvancedForm(){
                this.advanced_form = {
                    name: '',
                    address: '',
                    city: '',
                    state: '',
                    zip_code:'',
                    phone: '',
                    fax:'',
                    company_type:null
                };
            },
            editCode(company) {
                this.company = company;
                $("#clientIdModal").modal("show");
                this.editing = true;
                Object.assign(this.form, company.sequential_team_id);
            },

            saved() {
                let self = this;
                this.sequential_team_id = self.form.sequential_team_id;

                this.form.put(route('api.settings.codes.client-id.update', {company: this.company, sequential_team_id: this.sequential_team_id})).then(() => {
                    $("#clientIdModal").modal("hide");
                    location.reload();
                });
            },
        }
    }
</script>

<style>
    .pagination > li > a {
        color: #4dc0b5;
    }

    .pagination > li > a:hover {
        background-color: #4dc0b5 !important;
        color: white;
    }

    .cursor-pointer {
        cursor:pointer;
    }

    li.page-item.active > a {
        background-color: #4dc0b5 !important;
        border-color: #4dc0b5 !important;
    }

    a.page-link:focus {
        box-shadow: none;
    }
</style>
